<style lang="less" rel="stylesheet/less" scoped>
    ._header{
        padding:40px 0;
        /*background:linear-gradient(0deg,rgba(138,239,5,0.1),rgba(0,227,128,0.1));*/
        background: radial-gradient(650px 400px ellipse at 100px -70px,rgba(138,239,5,0.1),rgba(0,227,128,0.1) 50%,#fff 50%,#fff);
    }
    .arrow-icon{
        display:inline-block;
        position:relative;
        width:6px;
        height:21px;
        vertical-align: middle;
        top:-2px;

        &:before,&:after{
            content:'';
            display:block;
            height:10px;
            width:1px;
            background:#333;
            position:absolute;
            top:0;
            right:0;
            transform-origin: bottom center;
            transform:rotate(-20deg);
        }
        &:after{
            transform:rotate(200deg);
        }
    }
    .user-info{
        padding:0 20px;
        .right{
            float:right;
            line-height:50px;
        }
        .avatar{
            float:left;
            border-radius:99px;
            background:#eee;
            height:56px;
            width:56px;
        }
        .content{
            padding-left:70px;
            h2{
                font-size:18px;
                font-weight:bold;
                color:rgba(51,51,51,1);
                line-height:2em;
            }
            .desc{
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
            }
        }
    }
    .menus{
        .menu{
            height:30px;
            .icon{
                float:left;
                height:25px;
                width:25px;
                background:#eee;
            }
            .arrow-icon{
                float:right;
            }
            .title{
                line-height:25px;
                margin-left:40px;
            }
            .right{
                float:right;
            }
            padding:8px 20px;
        }
    }
</style>
<template>
    <div>
        <div class="_header">
            <div class="user-info">
                <div class="right" @click="$router.go({name:'me-edit'})">
                    编辑
                    <div class="arrow-icon"></div>
                </div>
                <div class="avatar"></div>
                <div class="content">
                    <h2>微信昵称</h2>
                    <div class="desc">
                        ID: 1000000
                    </div>
                </div>
            </div>
        </div>
        <div class="menus">
            <div class="menu">
                <div class="right">
                    <div class="arrow-icon"></div>
                </div>
                <div class="icon">

                </div>
                <div class="title">
                    用药设置提醒
                </div>
            </div>
            <div class="menu">
                <div class="right">
                    <div class="arrow-icon"></div>
                </div>
                <div class="icon">

                </div>
                <div class="title">
                    日常血糖检测记录
                </div>
            </div>
        </div>
        <BottomBar :index="2"></BottomBar>
    </div>
</template>
<script type="text/ecmascript-6">

    import BottomBar from '../components/BottomBar';

    export default {
        data() {
            return {}
        },
        computed: {},
        methods: {},
        components: {
            BottomBar,
        },
        mounted() {

        }
    }
</script>


// WEBPACK FOOTER //
// me.vue?058af561